import { FormEvent, useMemo, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import AuthLayout from '../../components/layout/AuthLayout';
import { useAuth } from '../../context/AuthContext';

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const presetEmail = useMemo(() => params.get('email') || '', [params]);
  const [email, setEmail] = useState(presetEmail);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) {
      setError('两次输入的密码不一致');
      return;
    }
    setSubmitting(true);
    try {
      await register(email, password);
      navigate('/sites/new', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : '注册失败');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout title="免费开通账号" subtitle="30 秒完成注册，无需绑定支付方式。">
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <label className="block">
          <span className="text-sm font-medium text-foreground-800">邮箱</span>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            className="mt-1.5 w-full px-4 py-3 rounded-md border border-background-200 bg-background-50 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300"
          />
        </label>
        <label className="block">
          <span className="text-sm font-medium text-foreground-800">密码</span>
          <input
            type="password"
            required
            minLength={6}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="至少 6 位"
            className="mt-1.5 w-full px-4 py-3 rounded-md border border-background-200 bg-background-50 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300"
          />
        </label>
        <label className="block">
          <span className="text-sm font-medium text-foreground-800">确认密码</span>
          <input
            type="password"
            required
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            placeholder="再输入一次密码"
            className="mt-1.5 w-full px-4 py-3 rounded-md border border-background-200 bg-background-50 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300"
          />
        </label>
        {error && <p className="text-sm text-primary-700">{error}</p>}
        <button
          type="submit"
          disabled={submitting}
          className="mt-1 w-full py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md disabled:opacity-60"
        >
          {submitting ? '创建中…' : '创建账号'}
        </button>
      </form>
      <p className="mt-6 text-sm text-foreground-600">
        已有账号？{' '}
        <Link to="/login" className="font-semibold text-primary-600 hover:text-primary-700">
          立即登录
        </Link>
      </p>
    </AuthLayout>
  );
}
